module.exports = __webpack_public_path__ + "images/emoji/sob.8a14abd72eb46557e7b4.png";